import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import api from '../config/api';
import MemoriesAlbumView from '../components/MemoriesAlbumView';
import { DOCUMENT, PAGE_CONTAINER_MAX_WIDTH, documentPageContainerSx } from '../constants/documentTheme';
import { memoriesPath } from '../utils/memoriesHost';

const MemoriesShare = () => {
  const { t } = useTranslation();
  const { code } = useParams();
  const navigate = useNavigate();
  const [slug, setSlug] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const shareCode = String(code || '').toUpperCase();
    (async () => {
      try {
        const { data } = await api.get(`/memories/share/${shareCode}`);
        if (cancelled) return;
        if (data.share?.slug) {
          setSlug(data.share.slug);
          return;
        }
        setError(t('memories.shareLinkMissing'));
      } catch (err) {
        if (cancelled) return;
        // QR/guest join codes mistakenly opened on /v/ — send them to join
        if (err.response?.status === 404) {
          navigate(memoriesPath(`j/${shareCode}`), { replace: true });
          return;
        }
        setError(err.response?.data?.error || t('memories.shareLinkMissing'));
      }
    })();
    return () => { cancelled = true; };
  }, [code, navigate, t]);

  if (error) {
    return (
      <Box sx={{ backgroundColor: DOCUMENT.canvas, minHeight: '100vh', pb: 8 }}>
        <Container maxWidth={PAGE_CONTAINER_MAX_WIDTH} sx={{ ...documentPageContainerSx, pt: 8 }}>
          <Typography sx={{ color: '#9C3B2A' }}>{error}</Typography>
        </Container>
      </Box>
    );
  }

  if (!slug) {
    return (
      <Box sx={{ backgroundColor: DOCUMENT.canvas, minHeight: '100vh', pb: 8 }}>
        <Container maxWidth={PAGE_CONTAINER_MAX_WIDTH} sx={{ ...documentPageContainerSx, pt: 8 }}>
          <Typography sx={{ color: DOCUMENT.ink3 }}>{t('common.loading')}</Typography>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: DOCUMENT.canvas, minHeight: '100vh', pb: 8 }}>
      <Container maxWidth={PAGE_CONTAINER_MAX_WIDTH} sx={{ ...documentPageContainerSx, pt: 3 }}>
        <MemoriesAlbumView slug={slug} shareCode={String(code || '').toUpperCase()} />
      </Container>
    </Box>
  );
};

export default MemoriesShare;
